import * as tslib_1 from "tslib";
import { settings } from '../../../settings';
import { Slugifier } from '../Slugifier';
import { AdditionalInputTypes, anyLocationForLanguage, Flow, flowContextMap, FlowRoutes, Language, Market, marketContextMap, ProductQueryParam, ProductType, SearchMaskGroupType, SearchMaskInputType, } from '../../../globalTypes';
import QueryCreator from '../QueryCreator';
import ContextCreator from '../ContextCreator';
import UserOptionsCreator from '../UserOptionsCreator';
import UserQueryCreator from '../UserQueryCreator';
import ProductQueryHelper from '../ProductQueryHelper';
import UserPaginationCreator from '../UserPaginationCreator';
import { optionAliasToParamMap, optionParamToAliasMap, optionParamToCoreMap, queryAliasToParamMap, queryParamToAliasMap } from './MappingConfig/urlMappingConfig';
import merge from 'deepmerge';
import { GeoTreeHelper } from "../../../util";
var LturRouter = /** @class */ (function () {
    function LturRouter() {
    }
    LturRouter.getContextFromUrl = function (location) {
        if (location === void 0) { location = document.location; }
        var pathName = location.pathname;
        var pathSegments = pathName.split('/').filter(function (pathSegment) { return pathSegment !== ''; });
        if (pathName === '' || pathSegments.length === 0) {
            return {};
        }
        var marketString = pathSegments.shift();
        var flowString = pathSegments.shift();
        // uses url based context with fallback to /de/last-minute
        var market = marketString && Market[marketString] ? Market[marketString] : Market.de;
        var flow = flowString && Flow[flowString] ? Flow[flowString] : Flow['last-minute'];
        var flowContext = flowString && Flow[flowString] ? flowContextMap.get(flow) : {
            productType: ProductType.PACKAGE,
            productChannel: 'DEFAULT'
        };
        var context = tslib_1.__assign({}, marketContextMap.get(market), flowContext);
        return context;
    };
    /**
     * Extracts from URL path the product group id if possible.
     * This method splits the path and uses slugified names to search
     * in geo tree received from core form data response.
     * For example from '/de/last-minute/spanien/balearen/mallorca' the group id '3534196' will be extracted
     */
    LturRouter.getProductGroupId = function (location, routeGroupIdMap) {
        if (location === void 0) { location = document.location; }
        var urlPath = location.pathname;
        var productGroupId = null;
        if (routeGroupIdMap) {
            while (!productGroupId && urlPath) {
                var productGroupIdValue = routeGroupIdMap[urlPath];
                if (productGroupIdValue) {
                    productGroupId = '' + productGroupIdValue;
                }
                var indexOfSlash = urlPath.indexOf('/');
                if (indexOfSlash < 0) {
                    urlPath = '';
                }
                else {
                    urlPath = urlPath.slice(indexOfSlash + 1);
                }
            }
        }
        return productGroupId;
    };
    /**
     * Extracts hotel code from URL path if possible.
     * For example from '/de/last-minute/hacienda-de-castilla-229208' the hotel code '229208' will be extracted
     *
     * @param location Window location object
     */
    LturRouter.getUrlHotelCode = function (location) {
        if (location === void 0) { location = document.location; }
        var hotelCode = null;
        var pathName = location.pathname;
        var hotelCodeRegex = /.*\-([0-9]{1,9}$)/g;
        var match = hotelCodeRegex.exec(pathName);
        if (match && match.length === 2) {
            hotelCode = match[1];
        }
        return hotelCode;
    };
    LturRouter.getUrlQueryOptions = function (location) {
        if (location === void 0) { location = document.location; }
        var getParams = new URLSearchParams(location.search.substring(1));
        var allOptionsParamsKeys = [];
        getParams.forEach(function (value, paramKey) {
            allOptionsParamsKeys = allOptionsParamsKeys.concat([paramKey]);
        });
        var allowedOptionParameters = Array.from(optionParamToCoreMap.keys());
        var allowedOptionParameterAliases = Array.from(optionParamToAliasMap.keys());
        var allowedOptionArray = merge(allowedOptionParameters, allowedOptionParameterAliases);
        var filteredOptionsParams = allOptionsParamsKeys.filter(function (paramKey) { return allowedOptionArray.includes(paramKey); });
        var options = filteredOptionsParams.reduce(function (aggregator, paramKey) {
            var _a;
            var currentParamValue = getParams.get(paramKey);
            var decoded;
            if (currentParamValue !== null) {
                var mappedParamKey = optionParamToAliasMap.get(paramKey);
                if (!mappedParamKey) {
                    mappedParamKey = paramKey;
                }
                try {
                    decoded = JSON.parse(decodeURI(currentParamValue ? currentParamValue : ''));
                }
                catch (e) {
                    decoded = decodeURI(currentParamValue ? currentParamValue : '');
                }
                return tslib_1.__assign({}, aggregator, (_a = {}, _a[mappedParamKey] = decoded, _a));
            }
            return aggregator;
        }, {});
        return options;
    };
    LturRouter.getUrlQueryParamsWithWhitelist = function (location, whitelist) {
        if (location === void 0) { location = document.location; }
        if (whitelist === void 0) { whitelist = []; }
        return this.getUrlQueryParamsForLocation(location, whitelist, true);
    };
    LturRouter.getUrlQueryParamsWithBlacklist = function (location, blacklist) {
        if (location === void 0) { location = document.location; }
        if (blacklist === void 0) { blacklist = []; }
        return this.getUrlQueryParamsForLocation(location, blacklist, false);
    };
    LturRouter.getUrlQueryParamsForLocation = function (location, paramKeysForFilterArray, whitelist) {
        if (location === void 0) { location = document.location; }
        if (paramKeysForFilterArray === void 0) { paramKeysForFilterArray = []; }
        if (whitelist === void 0) { whitelist = true; }
        var getParams = new URLSearchParams(location.search.substring(1));
        var allQueryParamsKeys = [];
        getParams.forEach(function (value, paramKey) {
            allQueryParamsKeys = allQueryParamsKeys.concat([paramKey]);
        });
        var filterParamFunction = function (allQueryKeys, filterKeys) {
            if (whitelist && filterKeys.length > 0 && allQueryKeys.length > 0) {
                return filterKeys.filter(function (key) { return allQueryKeys.includes(key); });
            }
            if (!whitelist && filterKeys.length > 0 && allQueryKeys.length > 0) {
                return allQueryKeys.filter(function (key) { return !filterKeys.includes(key); });
            }
            return allQueryParamsKeys;
        };
        var filteredQueryParams = filterParamFunction(allQueryParamsKeys, paramKeysForFilterArray);
        return filteredQueryParams.reduce(function (aggregator, paramKey) {
            var _a;
            var currentParamValue = getParams.get(paramKey);
            var mappedParamKey = queryParamToAliasMap.get(paramKey);
            if (!mappedParamKey) {
                mappedParamKey = paramKey;
            }
            if (currentParamValue !== null) {
                return tslib_1.__assign({}, aggregator, (_a = {}, _a[mappedParamKey] = LturRouter.decorateAndDecodeQueryParameter(mappedParamKey.toString(), currentParamValue), _a));
            }
            return aggregator;
        }, {});
    };
    LturRouter.decorateAndDecodeQueryParameter = function (paramName, paramValue) {
        var decodedValue = paramValue ? paramValue : '';
        try {
            if (ProductQueryHelper.isArrayParameter(paramName) && !decodedValue.startsWith('[')) {
                decodedValue = decodeURI(decodedValue).split(',').map(function (value) {
                    try {
                        return JSON.parse(value);
                    }
                    catch (e) {
                        return value;
                    }
                });
            }
            else {
                try {
                    decodedValue = JSON.parse(decodeURI(decodedValue));
                }
                catch (e) {
                    decodedValue = decodeURI(decodedValue);
                }
            }
        }
        catch (e) {
            decodedValue = undefined;
        }
        return decodedValue;
    };
    LturRouter.cleanQueryParameter = function (paramValue) {
        var cleanedValue = paramValue !== void 0 ? paramValue : '';
        if (Array.isArray(paramValue)) {
            cleanedValue = JSON.stringify(paramValue).slice(1, -1);
        }
        if (cleanedValue) {
            cleanedValue = ('' + cleanedValue).replace(/"/g, '');
        }
        return '' + cleanedValue;
    };
    LturRouter.generate = function (lturState, searchMaskGroupType, optionalQueries, forceDefaultPagination, forceDefaultSorting, resetHiddenFilters, resetStateParams, sorting) {
        if (optionalQueries === void 0) { optionalQueries = null; }
        if (forceDefaultPagination === void 0) { forceDefaultPagination = false; }
        if (forceDefaultSorting === void 0) { forceDefaultSorting = false; }
        if (resetHiddenFilters === void 0) { resetHiddenFilters = false; }
        if (resetStateParams === void 0) { resetStateParams = true; }
        if (sorting === void 0) { sorting = true; }
        var result = '';
        var slugifier = new Slugifier();
        var urlMarket = ContextCreator.create(lturState).country.toLowerCase();
        var flow = FlowRoutes['last-minute'];
        if (searchMaskGroupType === SearchMaskGroupType.HOTEL) {
            flow = FlowRoutes.hotel;
        }
        else {
            flow = FlowRoutes['last-minute'];
        }
        var routeSuffix = '';
        var optParam = tslib_1.__assign({}, QueryCreator.create(lturState, searchMaskGroupType, undefined, optionalQueries, resetHiddenFilters), UserOptionsCreator.create(lturState, searchMaskGroupType, null), UserQueryCreator.createAppUrl(lturState, searchMaskGroupType, resetStateParams), UserPaginationCreator.create(lturState, searchMaskGroupType, forceDefaultPagination, forceDefaultSorting));
        optParam = tslib_1.__assign({}, Object.keys(optParam).reduce(function (acc, key) {
            var _a;
            return tslib_1.__assign({}, acc, (_a = {}, _a[key] = '' + LturRouter.cleanQueryParameter(optParam[key]), _a));
        }, {}));
        if (lturState.websiteState
            && lturState.websiteState.searchMask.searchMaskBundle
            && lturState.websiteState.searchMask.searchMaskBundle.groups
            && lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]) {
            var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
            var destinationValue_1 = searchMaskGroup && searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue;
            if (optionalQueries) {
                optionalQueries.forEach(function (optionalQuery) {
                    if (optionalQuery.type === SearchMaskInputType.DESTINATION) {
                        destinationValue_1 = optionalQuery.confirmedValue;
                    }
                });
            }
            var language = lturState.websiteState.app.url.context && lturState.websiteState.app.url.context.language ?
                lturState.websiteState.app.url.context.language : 'de';
            optParam = tslib_1.__assign({}, optParam, { _market: urlMarket });
            routeSuffix = settings.routePartials.suffixes.destination;
            if (destinationValue_1 && destinationValue_1.value.type === AdditionalInputTypes.GENERATED_GROUP) {
                var groupId = destinationValue_1.value.group.properties.isLink ?
                    destinationValue_1.value.group.properties.linkTarget : destinationValue_1.value.group.id;
                optParam = tslib_1.__assign({}, optParam, { groupSlugs: lturState.websiteState.routing.routeSlugMap
                        ? lturState.websiteState.routing.routeSlugMap[groupId]
                        : anyLocationForLanguage.get(Language[language]) });
                if (groupId === GeoTreeHelper.getAllDestinationsNodeId(ProductType.PACKAGE) || groupId === GeoTreeHelper.getAllDestinationsNodeId(ProductType.HOTEL)) {
                    optParam = tslib_1.__assign({}, optParam, { PRODUCT_GROUPS: [], groupSlugs: anyLocationForLanguage.get(Language[language]) });
                }
                routeSuffix = settings.routePartials.suffixes.one_destination;
            }
            if (destinationValue_1 && destinationValue_1.value.type === 'HOTEL') {
                optParam = tslib_1.__assign({}, optParam, { hotelId: destinationValue_1.value.reference.value, hotelSlug: slugifier.slugify(destinationValue_1.value.value) });
                routeSuffix = settings.routePartials.suffixes.hotel_detail;
            }
            if (destinationValue_1
                && destinationValue_1.value.reference !== void 0
                && destinationValue_1.value.reference.value !== void 0
                && destinationValue_1.value.type !== 'HOTEL') {
                optParam = tslib_1.__assign({}, optParam, { groupSlugs: lturState.websiteState.routing.routeSlugMap
                        ? lturState.websiteState.routing.routeSlugMap[destinationValue_1.value.reference.value]
                        : anyLocationForLanguage.get(Language[language]) });
                routeSuffix = settings.routePartials.suffixes.one_destination;
            }
            var routeId = settings.routePartials.prefixes.ltur_app_frontend + '.' + flow + '.' + routeSuffix + '.' + urlMarket;
            if (lturState.websiteState && lturState.websiteState.routing.fos_router) {
                // Map parameter names to aliased parameter names
                optParam = tslib_1.__assign({}, Object.keys(optParam).reduce(function (acc, key) {
                    var _a;
                    var paramKey = queryAliasToParamMap.get(key);
                    if (!paramKey) {
                        paramKey = optionAliasToParamMap.get(key);
                    }
                    if (!paramKey) {
                        paramKey = key;
                    }
                    return tslib_1.__assign({}, acc, (_a = {}, _a[paramKey] = '' + LturRouter.cleanQueryParameter(optParam[key]), _a));
                }, {}));
                // Remove PRODUCT_GROUPS and HOTEL_CODES parameter from url
                delete optParam[ProductQueryParam.HOTEL_CODES];
                delete optParam[ProductQueryParam.PRODUCT_GROUPS];
                if (!sorting) {
                    delete optParam['sorting'];
                }
                result = lturState.websiteState.routing.fos_router.generate(routeId, optParam, false);
                result = decodeURIComponent(result);
                result = encodeURI(result);
            }
        }
        return result;
    };
    return LturRouter;
}());
export { LturRouter };
export default LturRouter;
